import { LinkifyLink } from "common";
import createLinkifyPlugin from "draft-js-linkify-plugin";

export const linkifyPlugin = createLinkifyPlugin({ component: LinkifyLink });
